import { useAuth } from '../../contexts/AuthContext';
import { useEffect, useState } from "react";
import {
  UserGroupIcon, ArrowRightIcon,
  UsersIcon,

  Squares2X2Icon,
  DocumentArrowDownIcon,
  AcademicCapIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import images from "../../components/images";
import StatCard from "../../components/StatCard";
import AddApplicationModal from "../../components/AddApplicationModal";
import AddUserModal from "../../components/AddUserModal";
import ExportReportsOffcanvas from "../../components/ExportReportsOffcanvas";
import TopApplications from '../../components/TopApplications';
import RecentUsers from '../../components/RecentUsers';
import { dashboardService } from '../../services/dashboardService';
import toast from 'react-hot-toast';

function AdminDashboard() {
  const { user, getAllDashboardData, loading } = useAuth()
  const [dashboardApplicationData, setDashboardApplicationData] = useState([])
  const [dashboardUserList, setDashboardUserList] = useState([])
  const [dashboardStats, setDashboardStats] = useState({})
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modelType, setModelType] = useState('')
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [loader, setLoader] = useState(false)

  const statsData = [
    {
      id: 1,
      title: dashboardStats?.active_users || '0',
      value: "Active Users",
      icon: UserGroupIcon,
      arrowColor: "text-blue-600",
      link: "/management/users",
      onclick: 'false'
    },
    {
      id: 2,
      title: dashboardStats?.active_applications || '0',
      value: "Active Applications",
      icon: Squares2X2Icon,
      arrowColor: "text-green-600",
      link: "/applications",
      onclick: 'false'
    },
    {
      id: 3,
      title: dashboardStats?.reports_exports || '0',
      value: "Reports Exported",
      icon: DocumentArrowDownIcon,
      arrowColor: "text-orange-600",
      link: "",
      onclick: 'true'
    },
    {
      id: 4,
      title: dashboardStats?.educator_count || '0',
      value: "Educators",
      icon: AcademicCapIcon,
      arrowColor: "text-green-600",
      link: "",
      onclick: 'false'
    },
    {
      id: 5,
      title: dashboardStats?.student_count || '0',
      value: "Students",
      icon: UserGroupIcon,
      arrowColor: "text-orange-600",
      link: "/management/users",
      onclick: 'false'
    },
    {
      id: 6,
      title: dashboardStats?.family_count || '0',
      value: "Parents",
      icon: UsersIcon,
      arrowColor: "text-red-600",
      link: "/management/users",
      onclick: 'false'
    },
  ];

  useEffect(() => {
    getDashboardData()
  }, [])

  const handleSave = (applicationData) => {
    console.log("Application saved:", applicationData);
    // Handle save logic here
  };

  const handleUserSave = (userData) => {
    console.log("User saved:", userData);
    // Handle user save logic here
  };

  const getDashboardData = async () => {
    try {
      setLoader(true)
      const response = await getAllDashboardData()
      if (response?.success == true) {
        setLoader(false)
        setDashboardApplicationData(response?.data?.applications)
        setDashboardUserList(response?.data?.usersList)
        setDashboardStats(response?.data?.stats)
      } else {
        setLoader(false)
        setDashboardApplicationData([])
        setDashboardUserList([])
        setDashboardStats({})
      }
    } catch (error) {
      setLoader(false)
      console.error('Error fetching dashboard data:', error)
    }
  }


  return (
    <>

      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">
            Admin Dashboard - Welcome, {user?.full_name}!
          </h1>
          {/* <p className="text-gray-600">System overview and management</p> */}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-6">

          {statsData.map((stat) => (
            <StatCard
              key={stat.id}
              icon={stat.icon}
              title={stat.title}
              value={stat.value}
              arrowColor={stat.arrowColor}
              link={stat.link}   // ✅ add this
              onclick={stat.onclick}
              setState={setIsExportModalOpen}
            />
          ))}

        </div>
        <div className='quick-links card bg-white shadow rounded-2xl border-0 p-5'>
          <p>Quick Actions</p>
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-3'>
            <div onClick={() => {
              setIsModalOpen(true);
              setModelType('New')
            }}
              className='bg-[#1D4ED80F] p-4 rounded-lg flex items-center justify-between cursor-pointer hover:bg-[#1d4ed847]'>
              <div className="flex items-center gap-2">
                <PlusIcon className="w-5 h-5 text-[#1D4ED8]" />
                <h6 className='text-[#1D4ED8] font-bold'>Add Application</h6>
              </div>
            </div>

            <div onClick={() => {
              setIsUserModalOpen(true)
            }} className='bg-[#16A34A0F] p-4 rounded-lg flex items-center justify-between cursor-pointer hover:bg-[#16a34a47]'>
              <div className="flex items-center gap-2">
                <img
                  src={images.AccessManage}
                  alt="Future Forward Logo"
                  className=" max-w-[24] h-[24px] "
                />
                <h6 className='text-[#16A34A] font-bold' > Add User</h6>
              </div>


            </div>

            <div
              // onClick={() => setIsExportModalOpen(true)}
              className='bg-[#FFA21D0F] p-4 rounded-lg flex items-center justify-between cursor-pointer hover:bg-[#ffa0182e]'>
              <div className="flex items-center gap-2">
                <img
                  src={images.ExportReport}
                  alt="Future Forward Logo"
                  className=" max-w-[24] h-[24px] "
                /> <h6 className='text-[#FFA21D] font-bold'>  Export Report</h6>
              </div>




            </div>
            <div className='bg-[#EA580C0F] p-4 rounded-lg flex items-center justify-between cursor-pointer hover:bg-[#ea580c26]'>
              <div className="flex items-center gap-2"> <img

                src={images.AddUser}
                alt="Future Forward Logo"
                className=" max-w-[24] h-[24px] "
              />
                <h6 className='text-[#EA580C] font-bold'> Manage Access</h6>
              </div>




            </div>


          </div>

        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* TopApplications spans 7 columns on large screens */}
          <div className="lg:col-span-7">
            <TopApplications data={dashboardApplicationData} loader={loader} />
          </div>

          {/* RecentUsers spans 5 columns on large screens */}
          <div className="lg:col-span-5">
            <RecentUsers data={dashboardUserList} loader={loader} />
          </div>
        </div>







        <AddApplicationModal
          isOpen={isModalOpen}
          onClose={setIsModalOpen}
          type={modelType}
          selectedApp={null}
          setSelectedApp={() => { }}
          setModelType={setModelType}
          getAllApplicationList={() => { }}
        />
        <AddUserModal
          isOpen={isUserModalOpen}
          onClose={() => setIsUserModalOpen(false)}
          onSave={() => {
            console.log("User Form Submitted ✅");
            setIsUserModalOpen(false);
          }}
        />

        <ExportReportsOffcanvas
          isExportModalOpen={isExportModalOpen}
          onClose={() => setIsExportModalOpen(false)}
        />


      </div>
    </>
  )
}

export default AdminDashboard